<div class="button-style-modal-wrapper">
  <div class="button-style-modal-header">
    <span> Button Color </span>
    <button (click)="closeModal()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="button-style-modal-content">
    <span> Please select a button color </span>
    <div class="color-picker-wrapper">
      <mat-menu #menu="matMenu" [yPosition]="'above'" [xPosition]="'after'">
        <div>
          <span
            [style.background]="color"
            [cpToggle]="true"
            [cpDialogDisplay]="'inline'"
            [cpOutputFormat]="'hex'"
            [cpCancelButton]="false"
            [(colorPicker)]="color"
            class="pick-color-custom"
          ></span>
        </div>
      </mat-menu>
      <div class="color-picker-button" [matMenuTriggerFor]="menu" [style]="{ background: color }"></div>
      <span>{{ color }}</span>
    </div>
  </div>
  <div class="button-style-modal-preview">
    <span>Button Preview</span>
    <button class="button-preview" [style]="{ background: color, color: getTextColor(color) }">Start now</button>
  </div>
  <div class="flex items-center justify-between">
    <app-home-button [color]="'white'" (click)="pickColor()">Cancel</app-home-button>
    <app-home-button (click)="pickColor()">Confirm Color Selection</app-home-button>
  </div>
</div>
